import { render, staticRenderFns } from "./ProductPackage.vue?vue&type=template&id=648fe594&scoped=true"
import script from "./ProductPackage.vue?vue&type=script&lang=js"
export * from "./ProductPackage.vue?vue&type=script&lang=js"
import style0 from "./ProductPackage.vue?vue&type=style&index=0&id=648fe594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648fe594",
  null
  
)

export default component.exports